import React, { Component } from 'react';
import './App.css';
import Home from './components/Home/Home';

export default class App extends Component {
  render() {
    return (
      <div className="App">
        <Home/>
      </div>
    );
  }
}